import { MydocmaPromptButtonTypeEnum } from '@mydocma/component-library/src/lib/prompt-dialog';
import { TranslateService } from '@ngx-translate/core';

export type FaultActionDialogType = 'removeUnsynced' | 'remove' | 'downloadUnsyncedFault' | 'downloadUnsyncedFaults' | 'refreshFaultsInLocalMode';

export interface FaultActionDialogConfig {
  title: string;
  content: string;
  buttons: {
    type: MydocmaPromptButtonTypeEnum;
    text: string;
    value: boolean;
  }[];
}

export function buildFaultActionDialog(
  type: FaultActionDialogType,
  translate: TranslateService
): FaultActionDialogConfig {
  switch (type) {
    case 'removeUnsynced':
      return {
        title: translate.instant('MM.dialog.removeUnsyncedFaultDownload.title'),
        content: translate.instant('MM.dialog.removeUnsyncedFaultDownload.content'),
        buttons: [
          { type: MydocmaPromptButtonTypeEnum.default, text: translate.instant('MM.general.no'), value: false },
          { type: MydocmaPromptButtonTypeEnum.warn, text: translate.instant('MM.general.yes'), value: true }
        ]
      };

    case 'remove':
      return {
        title: translate.instant('MM.dialog.removeFaultDownload.title'),
        content: translate.instant('MM.dialog.removeFaultDownload.content'),
        buttons: [
          { type: MydocmaPromptButtonTypeEnum.default, text: translate.instant('MM.general.no'), value: false },
          { type: MydocmaPromptButtonTypeEnum.warn, text: translate.instant('MM.general.yes'), value: true }
        ]
      };

    case 'downloadUnsyncedFault':
      return {
        title: translate.instant('MM.dialog.downloadUnsyncedFault.title'),
        content: translate.instant('MM.dialog.downloadUnsyncedFault.content'),
        buttons: [
          { type: MydocmaPromptButtonTypeEnum.default, text: translate.instant('MM.general.button.cancel'), value: false },
          { type: MydocmaPromptButtonTypeEnum.primary, text: translate.instant('MM.general.button.synchronize'), value: true }
        ]
      };
    case 'downloadUnsyncedFaults':
        return {
          title: translate.instant('MM.dialog.downloadUnsyncedFaults.title'),
          content: translate.instant('MM.dialog.downloadUnsyncedFaults.content'),
          buttons: [
            {
              type: MydocmaPromptButtonTypeEnum.default,
              text: translate.instant('MM.general.button.cancel'),
              value: false
            },
            {
              type: MydocmaPromptButtonTypeEnum.primary,
              text: translate.instant('MM.general.button.synchronize'),
              value: true
            }
          ]
        };
    case 'refreshFaultsInLocalMode':
      return {
        title: translate.instant('MM.dialog.refreshFaultsInLocalMode.title'),
        content: translate.instant('MM.dialog.refreshFaultsInLocalMode.content'),
        buttons: [
          { type: MydocmaPromptButtonTypeEnum.default, text: translate.instant('MM.general.no'), value: false },
          { type: MydocmaPromptButtonTypeEnum.primary, text: translate.instant('MM.general.yes'), value: true }
        ]
      }
  }
}
